import {
  scheduleTime,
  scheduleTimeForFirstStep,
  immediateDelay,
} from '@/constants/outreach-delay-time';

/**
 * Resolve an outreach step's delay option by its stored interval value.
 *
 * Relocated here from `src/pages/mco/steps/components/step/delay.js` so
 * cross-feature consumers (the shared step view) can use it without importing
 * into the mco page layer. The original module re-exports this for
 * within-feature callers.
 */
const MINUTES_PER_HOUR = 60;
const MINUTES_PER_DAY = 1440;

const pluralise = (count: number, unit: string) =>
  `${count} ${unit}${count === 1 ? '' : 's'}`;

/**
 * Label for an interval that none of the delay options carries, in the same
 * style as the option labels ('10 Mins', '3 Hrs', '2 Days').
 */
export const formatDelayMinutes = (minutes: number): string => {
  if (minutes % MINUTES_PER_DAY === 0) {
    return pluralise(minutes / MINUTES_PER_DAY, 'Day');
  }
  if (minutes % MINUTES_PER_HOUR === 0) {
    return pluralise(minutes / MINUTES_PER_HOUR, 'Hr');
  }
  return pluralise(minutes, 'Min');
};

export const getDelayById = (stepInterval) => {
  const delay = [
    ...scheduleTime,
    ...scheduleTimeForFirstStep,
    ...immediateDelay,
  ];
  const option = delay.find((time) => time.value === stepInterval);
  if (option) return option;

  // A stored interval the options don't list (set outside the step form, e.g.
  // 1 minute) used to resolve to undefined: the schedule chip rendered blank
  // and the step forms, which require every value, kept Save disabled with no
  // way to tell why. Keep the step's real interval instead.
  if (typeof stepInterval === 'number' && stepInterval > 0) {
    return { label: formatDelayMinutes(stepInterval), value: stepInterval };
  }
  return undefined;
};
